import { useState } from 'react';
import { SearchInput } from 'components/SearchInput';
import { SearchProperties } from './types';
import { DEFAULT_SEARCH_PLACEHOLDER, DEFAULT_SEARCH_TESTID } from './constants';

const Search = ({
  placeholder,
  value: _value,
  testId,
  onChange,
}: SearchProperties) => {
  const [value, setValue] = useState(_value || undefined);
  return (
    <SearchInput
      placeholder={placeholder ?? DEFAULT_SEARCH_PLACEHOLDER}
      data-testid={testId ?? DEFAULT_SEARCH_TESTID}
      onInput={(value) => {
        setValue(value);
        onChange?.(value);
      }}
      style={{
        width: '100%',
      }}
      value={value || ''}
    ></SearchInput>
  );
};

export default Search;
